import { LogicOperator, Role } from '@okletsplay/core';
import { Route } from 'app/enums';
import { GuardedRoute } from 'app/interfaces/route';
import { rolesGuard } from 'app/routing/guards';
import { lazyRetry } from 'app/utils';
import TournamentPage from 'modules/tournaments/pages/TournamentPage';

const CreateTournamentPage = lazyRetry(
  () => import('modules/tournaments/pages/CreateTournamentPage')
);
const TournamentAdminPage = lazyRetry(
  () => import('modules/tournaments/pages/TournamentAdminPage')
);
const CreateTournamentSuccessPage = lazyRetry(
  () => import('modules/tournaments/pages/CreateTournamentSuccessPage')
);
const MyActiveTournamentsPage = lazyRetry(
  () => import('modules/tournaments/pages/MyActiveTournamentsPage')
);
const MyPastTournamentsPage = lazyRetry(
  () => import('modules/tournaments/pages/MyPastTournamentsPage')
);

export const TournamentsRoutes: GuardedRoute[] = [
  {
    path: Route.CreateTournament,
    name: 'Create Tournament',
    component: CreateTournamentPage,
    availability: [],
    guards: [],
  },
  {
    path: Route.TournamentRoot,
    name: 'Tournament',
    component: TournamentPage,
    availability: [],
    guards: [],
  },
  {
    path: Route.TournamentEdit,
    name: 'Edit Tournament',
    component: TournamentAdminPage,
    availability: [],
    guards: [],
  },
  {
    path: Route.CreateTournamentSuccess,
    name: 'Create Tournament Success',
    component: CreateTournamentSuccessPage,
    availability: [Role.CommunityTournamentCreator, Role.TournamentCreator],
    guards: [
      rolesGuard([Role.CommunityTournamentCreator, Role.TournamentCreator], LogicOperator.OR),
    ],
  },
  {
    path: Route.MyActiveTournaments,
    name: 'My Active Tournaments',
    component: MyActiveTournamentsPage,
    availability: [Role.CommunityTournamentCreator, Role.TournamentCreator],
    guards: [
      rolesGuard([Role.CommunityTournamentCreator, Role.TournamentCreator], LogicOperator.OR),
    ],
  },
  {
    path: Route.MyPastTournaments,
    name: 'My Past Tournaments',
    component: MyPastTournamentsPage,
    availability: [Role.CommunityTournamentCreator, Role.TournamentCreator],
    guards: [
      rolesGuard([Role.CommunityTournamentCreator, Role.TournamentCreator], LogicOperator.OR),
    ],
  },
];
